import axios from 'axios';

import { NOTIFICATIONS_API_ENDPOINT } from 'constants/api';

const notificationsAPI = axios.create({
  baseURL: NOTIFICATIONS_API_ENDPOINT,
});

export default notificationsAPI;
